<template>
  <div class="custom-radio" @click="$emit('change')">
    <div class="wrap">
      <div class="radio" :class="{ checked: checked }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CRadio',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.checked,
    }
  },
  watch: {
    value(val) {
      this.$emit('update:value', val)
      this.$emit('change', val)
    },
  },
}
</script>


<style scoped lang="scss">
.custom-radio {
  position: relative;

  .wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border: 2px solid var(--primary);
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;
  }

  .radio {
    width: 65%;
    height: 65%;
    position: relative;
    background: transparent;
    border: 2px solid var(--primary);
    border-radius: 50%;
    flex-shrink: 0;
    &.checked {
      background-color: var(--primary);
    }
  }


}

</style>
